import { server } from '../core/server/axios';
import { BACKEND_URL } from '@/core/config';
import { AfmContryModel } from './DocumentsController';
import { DocumentType } from '@/constatns';

export interface ClientInfo {
    firstName: string;
    middleName: string;
    lastName: string;
    iin: string;
    phone: string;
    citizen: string;
    citizenCode: string;
    birthday: Date | null;
    isResident: boolean;
    isAffiliated: boolean;

    doctype: "" | DocumentType;
    series: string;
    docNumber: string;
    issuePlace: string;
    issueDate: Date | null;
    validDate: Date | null;

    photoImg: string;
    signImg: string;

    clientId: number;
    docId: number;
    adrId: number;

    country: string;
    countryCode: string;
    region: string;
    postIndex: string;
    locality: string;
    township: string;
    street: string;
    number: string;
    flat: string;
}

export interface Document {
    docId: number;
    series: string;
    docType: string;
    docNumber: string;
    issuePlace: string;
    issueDate: string;  // Используйте тип Date, если хотите работать с датами
    validDate: string;  // Используйте тип Date, если хотите работать с датами
    content: string;
    clientId: number;
    citizen: string;
    citizenCode: string;
    isResident: boolean;
}

export interface Address {
    adrId: number;
    country: string;
    countryCode: string | null;
    region: string;
    locality: string;
    township: string;
    street: string;
    number: string;
    flat: string;
    clientId: number;
    postIndex: number;
}

export interface Client {
    clientId: number;
    firstName: string;
    middleName: string;
    lastName: string;
    iin: string;
    phone: string;
    birthDay: string;  // Используйте тип Date, если хотите работать с датами
    isResident: boolean;
    isAffiliated: boolean;
    /** Логин instagram клиента, может прийти как с собачкой, так и без */
    instagramNickname?: string | null;
    documents: Document[];
    clientAdress: Address[];
    tenantId: number[];
}
export class ClientController {
    async addClient(request: {
        firstName: string;
        middleName: string;
        lastName: string;
        iin: string;
        phone: string;
        birthDay: Date | null;
        isAffiliated: boolean;
        tenantId: number;
    }): Promise<any> {
        return await server.post('/Client/NewClient', request, {
            baseURL: BACKEND_URL
        });
    }

    async updateClient(request: {
        clientId: number,
        firstName: string;
        middleName: string;
        lastName: string;
        iin: string;
        phone: string;
        birthDay: Date | null;
        isAffiliated: boolean;
        tenantId: number;
    }): Promise<any> {
        return await server.patch('/Client/UpdateClient', request, {
            baseURL: BACKEND_URL
        });
    }

    async documents(request: {
        docId?: number | string,
        series: string,
        docType: string,
        docNumber: string,
        issuePlace: string,
        issueDate: Date | null,
        validDate: Date | null,
        content: string,
        clientId: number | string,
        citizen: string,
        citizenCode: string,
        isResident: boolean,
    }): Promise<Document> {
        return await server.post('/Client/Documents', request, {
            baseURL: BACKEND_URL
        });
    }

    async Adress(request: {
        adrId?: number | string,
        country: string,
        countryCode: string,
        region: string,
        postIndex: string,
        locality: string,
        township: string,
        street: string,
        number: string,
        flat: string,
        clientId: number | string
    }): Promise<Address> {
        return await server.post('/Client/Adress', request, {
            baseURL: BACKEND_URL
        });
    }

    async bindAffiliate({
        isMainAffiliate,
        clientId,
        mainClientId,
        relationType,
        direction,
    }: {
        isMainAffiliate: boolean,
        clientId: number | string,
        mainClientId: number | string,
        relationType: string,
        direction: string
    }): Promise<any> {
        return await server.post('/Client/bindAffiliate', {
            isMainAffiliate,
            clientId,
            mainClientId,
            relationType,
            direction,
        }, {
            baseURL: BACKEND_URL
        });
    }

    async searchClient({ iin = null, lastName = null, firstName = null, phone = null }: { iin?: string | null, lastName?: string | null, firstName?: string | null, phone?: string | null }): Promise<{ model: Client[] }> {
        return await server.post(`/Client/SearchClient?${iin ? `iin=${iin}` : ""}${iin && lastName ? "&" : ""}${lastName ? `lastname=${lastName}` : ""}${firstName ? `&firstName=${firstName}` : ""}${phone ? `phone=${phone}` : ""}`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getCountryList(): Promise<AfmContryModel[]> {
        return await server.get('/Generic/CountryList', {
            baseURL: BACKEND_URL
        });
    }

    async getIssuerPlaces(citizenCode: string): Promise<{ isSuccess: string; message: string; issuePlaces: string[]; }> {
        return await server.get(`/Client/getIssuerPlaces/${citizenCode}`, {
            baseURL: BACKEND_URL
        });
    }

    async buildIssuerPlaces(): Promise<any> {
        return await server.post(`/Client/buildIssuerPlaceReference`, {}, {
            baseURL: BACKEND_URL
        });
    }

    async getClientOperations(clientId: string | number): Promise<any> {
        return await server.get(`/Client/ClientRequests/${clientId}`, {
            baseURL: BACKEND_URL
        });
    }

    async getClientDocuments(docNumber: string): Promise<any> {
        return await server.get(`/Client/getClientDocuments/${docNumber}`, {
            baseURL: BACKEND_URL
        });
    }
}